import type {ComponentExportStructure} from '@wix/document-services-types'
import type {DecorationSingleComponentPluginFunction} from '../../types'

export const pack: DecorationSingleComponentPluginFunction = (component: ComponentExportStructure) => {
    if (!component.skin) {
        return
    }

    component.structure ??= {}
    component.structure.skin = component.skin
    delete component.skin
}
